module.exports = __webpack_public_path__ + "static/media/potential-energy.08d698b4.svg";